//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        color: {
            type: String,
            default: 'green'
        },
        text: {
            type: String,
            default: ''
        },
        fontSize: {
            type: String,
            default: 'text-xs'
        }
    }
};
